@for (selectedFile of selectedFiles; track selectedFile; let i = $index) {
  <div class="selected-files">
    <a href="#" (click)="downloadFile($event, i)">
      {{ selectedFile.fileName }} ({{ selectedFile.sizeInBytes! | fileSize }})
    </a>

    @if (!viewOnly) {
      <button
        (click)="removeFile(i)"
        aria-label="Clear"
        mat-icon-button
        matSuffix
        type="button"
      >
        <mat-icon color="warn">delete</mat-icon>
      </button>
    }
  </div>
}

@if (!viewOnly && !(!multiple && selectedFiles.length > 0)) {
  <div class="buttons">
    <input
      #fileInput
      (change)="addFile($event);"
      (click)="fileInput.value = ''"
      [multiple]="multiple"
      accept="{{validFileExtensions}}"
      type="file"
      value=""
      hidden
    >

    <button
      (click)="fileInput.click()"
      mat-raised-button
      type="button"
      value="Choose File"
    >
      {{ "ACTIONS.UPLOAD" | translate }}
    </button>
  </div>
}
